module.exports = __webpack_public_path__ + "static/media/Bronze.4e7822a7.png";